import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { EVENT_TYPE, BRANCH_EVENTS } from 'resources'
import { initAnalytics, sendAnalyticsEvent, sendBranchEvent } from 'services/analytics'
import { intercomSetLauncherVisibility, registerIntercomUser } from 'services/Intercom'
import { branchSetIdentity } from 'services/branch'
import { setSentryUser } from 'services/Sentry'

export const WithAnalyticsHandlers = ({
  children,
  updateAnalyticsUserId,
  setReklaimRewardsTag,
  isAuthenticated,
  fetchIntercomUserHash,
  accountId = '',
  intercomUserHashWeb = null,
  userAlias = '',
}) => {
  useEffect(() => {
    initAnalytics()
  }, [])

  useEffect(() => {
    sendAnalyticsEvent(EVENT_TYPE.appLaunchAppLaunch)
    sendBranchEvent(BRANCH_EVENTS.openApp)
  }, [])

  useEffect(() => {
    if (isAuthenticated) {
      fetchIntercomUserHash()
    }
    intercomSetLauncherVisibility(!isAuthenticated)
  }, [isAuthenticated, fetchIntercomUserHash])

  useEffect(() => {
    if (userAlias && intercomUserHashWeb && isAuthenticated) {
      registerIntercomUser(userAlias, intercomUserHashWeb)
      setReklaimRewardsTag()
    }
  }, [intercomUserHashWeb, userAlias, isAuthenticated, setReklaimRewardsTag])

  useEffect(() => {
    if (userAlias) {
      branchSetIdentity(userAlias)
      setSentryUser(userAlias)
    }
  }, [userAlias])

  useEffect(() => {
    updateAnalyticsUserId(accountId)
  }, [accountId, updateAnalyticsUserId])

  return children
}

WithAnalyticsHandlers.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  updateAnalyticsUserId: PropTypes.func.isRequired,
  setReklaimRewardsTag: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  fetchIntercomUserHash: PropTypes.func.isRequired,
  accountId: PropTypes.string,
  userAlias: PropTypes.string,
  intercomUserHashWeb: PropTypes.string,
}

export default WithAnalyticsHandlers
